/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { TesterNavigationHeaderSearchComponent } from './tester-navigation-header-search/tester-navigation-header-search.component';
import { TesterNavigationHeaderChatComponent } from './tester-navigation-header-chat/tester-navigation-header-chat.component';
import { TesterNavigationHeaderSupportComponent } from './tester-navigation-header-support/tester-navigation-header-support.component';
import { TesterNavigationHeaderNotificationsComponent } from './tester-navigation-header-notifications/tester-navigation-header-notifications.component';
import { TesterNavigationHeaderAccountComponent } from './tester-navigation-header-account/tester-navigation-header-account.component';
import { TesterNavigationMobileMenuService } from '../tester-navigation-mobile-menu.service';

@Component({
    selector: 'ngf-tester-navigation-header',
    templateUrl: './tester-navigation-header.component.html',
    styleUrls: ['./tester-navigation-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        AsyncPipe,
        TesterNavigationHeaderSearchComponent,
        TesterNavigationHeaderChatComponent,
        TesterNavigationHeaderSupportComponent,
        TesterNavigationHeaderNotificationsComponent,
        TesterNavigationHeaderAccountComponent,
    ]
})
export class TesterNavigationHeaderComponent implements OnInit, OnDestroy {
  /** URL to the notifications/activity page. Differs between apps. */
  @Input() notificationsUrl = '/activity';

  /** Pass the current search query to pre-populate the search box (e.g. on the search results page). */
  @Input() searchQuery?: string;

  /** Set to false to hide the search box (e.g. for private-community tester users). */
  @Input() showSearch = true;

  /** Set to false to hide the notifications bell (e.g. for private-community tester users). */
  @Input() showNotifications = true;

  /** Logo shown in the mobile header. Mirrors the sidebar's logoSrc input. */
  @Input() logoSrc = 'assets/images/uTestLogoNav.svg';

  /** href for the mobile logo link. Mirrors the sidebar's home URL. */
  @Input() logoHref = '/';

  /** Emitted when the user submits a search query. The app handles navigation. */
  @Output() searchSubmit = new EventEmitter<string>();

  searchOpen = false;
  private mobileMenuSub = Subscription.EMPTY;

  constructor(readonly mobileMenuService: TesterNavigationMobileMenuService) {}

  ngOnInit(): void {
    this.mobileMenuSub = this.mobileMenuService.isOpen$.subscribe(open => {
      if (open) this.searchOpen = false;
    });
  }

  ngOnDestroy(): void {
    this.mobileMenuSub.unsubscribe();
  }

  toggleSearch(): void {
    this.searchOpen = !this.searchOpen;
  }

  onMobileSearch(query: string): void {
    this.searchSubmit.emit(query);
    this.searchOpen = false;
  }
}
